/**
 * Canonical Platform Theme Authority
 * Re-exports the single platform Zustand theme store instance.
 * Shared across Cockpit, DoD Workspace, and Flight Showroom.
 */
import { useDoDThemeStore, DoDThemeMode, DoDThemeTokens, DARK_THEME, LIGHT_THEME } from './useDoDThemeStore';

export type ThemeMode = 'dark' | 'light' | DoDThemeMode;

export const useThemeStore = useDoDThemeStore;
export { useDoDThemeStore, DARK_THEME, LIGHT_THEME };
export type { DoDThemeMode, DoDThemeTokens };
